import React from 'react';
import experimentState from "./state/experimentState";
import themeState from "./state/themeState";

class Message extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            message: props.message,
            user: props.user,
            isme: props.isme,
            type: props.type,
            idx: props.idx,
            prevSame: props.prevSame,
            nextSame: props.nextSame
        }

    }

    render() {
        let time_left = 1
        if (this.state.type === "warning") {
            return <div id={`message-${this.state.idx}`}
                        className="contextual-message text-warning">{this.state.message}</div>
        } else if (this.state.type === "muted") {
            return <div id={`message-${this.state.idx}`}
                        className="contextual-message text-muted">{this.state.message}</div>
        } else if (this.state.type === "danger") {
            return <div id={`message-${this.state.idx}`}
                        className="contextual-message text-danger">{this.state.message}</div>
        }
        else {
            let is_me = this.state.user === ((experimentState.experimentParams.admin)? "Interviewer" : "Participant")
            let colour = is_me ? themeState.colour_secondary : themeState.colour_tertiary

            let margin = `${this.state.prevSame ? "1px" : "5px"} 5px ${this.state.nextSame ? "1px" : "5px"} 5px`
            let user_or_time = is_me ? "Uzelf" : this.state.user
            if (this.props.type === "question") {
                time_left = Math.min(Math.max(0,Math.floor(((this.props.start + (this.props.timeout) * 1000) - this.props.now) / 100) / 10),10)
                time_left = this.props.nextTime? 0 : time_left
                user_or_time = `  ${time_left.toFixed(1)}s  `
                if (time_left === 0 && this.props.nextTime) {
                    user_or_time = "       "
                }
            }
            let borderRadius = `${(!is_me && this.state.prevSame) ? "3px" : "10px"} ${is_me && this.state.prevSame ? "3px" : "10px"} ${is_me ? "3px" : "10px"} ${!is_me ? "3px" : "10px"}`

            return <div id={`message-${this.state.idx}`}
                        style={{
                            minHeight: "64spx",
                            display: "flex",
                            margin: margin,
                            alignItems: "stretch",
                            flexDirection: themeState.rowDir[is_me ^ themeState.chat_panel_form_flex_direction],
                            border: `solid 2px ${colour}`,
                            maxWidth:"100%",
                            borderRadius: borderRadius,
                            alignSelf: themeState.flexDir[is_me ^ themeState.chat_panel_form_flex_direction]
                        }}>
                <span
                    style={{
                        color: (time_left !== 0)? colour : themeState.colour_text,
                        // border: `solid 2px ${colour}`,
                        // borderStyle: "solid",
                        // borderWidth: "2px",
                        // borderRadius: "10px",
                        textAlign: "left",
                        lineHeight: "1.5em",
                        padding: "1em",
                        backgroundColor: (time_left !== 0)? "" : (this.props.nextTime? themeState.colour_within_time : themeState.colour_time_up)
                    }}>{user_or_time}</span>
                <pre style={{
                    backgroundColor: colour,
                    color: themeState.colour_text,
                    // borderRadius: "10px",
                    padding: "1em",
                    textAlign: "left",
                    lineHeight: "1.5em",
                    // overflowX:"auto",
                    whiteSpace: "pre-wrap",
                    // wordWrap: "break-word",
                    wordBreak:"break-word",
                    flexGrow: "2"
                }}
                >{this.state.message}
                </pre>
            </div>
        }
    }
}

export default Message;